<template>
  <div class="background_index_contact">
    <div class="index_contact_text">
      <p style="font-size: 18px;font-weight: bolder">Contact</p>
      <p>Shanghai Address</p>
      <p>Suite 1705-09, 1 Corporate Avenue, 222 Hu Bin Road,</p>
      <p>Huangpu District, Shanghai</p>
      <p>P.C.：200021，Tel：(+86) 21-61222888</p>
      <p>Fax：(+86）21-61130320</p>
      <p>Email：ChinaPIM@Sig.Com</p>
    </div>
  </div>
  <Footer_m></Footer_m>
</template>

<script>
import Footer_m from "@/components/CN_mobile/Footer_m";
import {reactive, onMounted} from 'vue'

export default {
  name: 'Index_contact_en_m',
  components: {
    Footer_m,
  },
  setup() {
    const logo = reactive({
      items: [],
    })
    onMounted(() => {
      const files = require.context('../../../assets/logo').keys()
      for (let item of files) {
        logo.items.push(require('../../../assets/logo' + item.substring(1)))
      }
    })
    return {logo,}
  }
}

</script>
<style scoped>
.background_index_contact {
  background-image: url("../../../assets/background/index_contact.jpg");
  height: 80vh;
  background-repeat: no-repeat;
  background-position: center;
  background-size: auto 100%;
  margin: 0;
  padding: 0 5vw;
}

.index_contact_text {
  text-align: center;
  padding-top: 30vh;
  padding-left: 5vw;
}

.index_contact_text p {
  font-size: 12px;
}

</style>